import React from 'react'
import './About.css'



export default function About() {
    return (
        <div className='about_component'>
            <img src='/hackathon_image.png' className='hackathon_image' alt='hackathon'></img>
            <div className='aboutContent'>
                <p className='hackathonMainName'>EVENT MANAGEMENT CHALLENGE</p>
                <p className='about_text'>ABOUT THE CHALLENGE</p>
                <p className='hackathon_description' style={{ marginBottom: "0px" }}>Unlock the power of 8+ years of event data from across India in this one-of-a-kind analytics
                    challenge! The KSR Datavizon Megathon invites participants to
                    dive deep into event trends and discover what truly drives success in the world of events.
                </p>

                <p className='hackathon_description' style={{ marginTop: "-5px" }}>This includes information such as event names, categories, dates, locations, organizers, pricing, attendee statistics, event
                    formats, and feedback ratings. Participants are challenged to leverage Power BI to explore and analyze this dataset,
                    uncovering valuable insights that can help in understanding.</p>
            </div>
        </div>
    )
}
